import { supabase } from '../../lib/supabaseClient';

export interface TaskTag {
  id: string;
  name: string;
  color: string;
  created_by: string | null;
  created_at: string;
}

export async function listTaskTags(): Promise<TaskTag[]> {
  const { data, error } = await supabase
    .from('task_tags')
    .select('*')
    .order('name', { ascending: true });
  if (error) throw error;
  return (data ?? []) as TaskTag[];
}

export async function createTaskTag(name: string, color: string): Promise<TaskTag> {
  const { data, error } = await supabase
    .from('task_tags')
    .insert({ name: name.trim(), color })
    .select()
    .single();
  if (error) throw new Error(`Impossible de créer le tag : ${error.message}`);
  return data as TaskTag;
}

export async function updateTaskTag(
  id: string,
  patch: { name?: string; color?: string },
): Promise<TaskTag> {
  const update: { name?: string; color?: string } = {};
  if (patch.name !== undefined) update.name = patch.name.trim();
  if (patch.color !== undefined) update.color = patch.color;
  const { data, error } = await supabase
    .from('task_tags')
    .update(update)
    .eq('id', id)
    .select()
    .single();
  if (error) throw new Error(`Impossible de modifier le tag : ${error.message}`);
  return data as TaskTag;
}

export async function deleteTaskTag(id: string): Promise<void> {
  const { error } = await supabase.from('task_tags').delete().eq('id', id);
  if (error) throw new Error(`Impossible de supprimer le tag : ${error.message}`);
}

export async function getTaskTagsFor(
  taskIds: string[],
): Promise<Record<string, TaskTag[]>> {
  if (taskIds.length === 0) return {};
  const { data, error } = await supabase
    .from('task_tag_assignments')
    .select('task_id, task_tags(*)')
    .in('task_id', taskIds);
  if (error) throw new Error(`Impossible de charger les tags : ${error.message}`);

  const result: Record<string, TaskTag[]> = {};
  for (const row of data ?? []) {
    const taskId = row.task_id as string;
    const tag = row.task_tags as unknown as TaskTag | null;
    if (!tag) continue;
    if (!result[taskId]) result[taskId] = [];
    result[taskId].push(tag);
  }
  return result;
}

export async function setTaskTags(taskId: string, tagIds: string[]): Promise<void> {
  const { error: delErr } = await supabase
    .from('task_tag_assignments')
    .delete()
    .eq('task_id', taskId);
  if (delErr) throw new Error(`Impossible de mettre à jour les tags : ${delErr.message}`);
  if (tagIds.length === 0) return;
  const { error } = await supabase
    .from('task_tag_assignments')
    .insert(tagIds.map((tag_id) => ({ task_id: taskId, tag_id })));
  if (error) throw new Error(`Impossible d'assigner les tags : ${error.message}`);
}
